import script from "./FormMessages.vue?vue&type=script&lang=js"
export * from "./FormMessages.vue?vue&type=script&lang=js"

import "./FormMessages.vue?vue&type=style&index=0&id=3662c630&lang=scss"

const __exports__ = script;

export default __exports__